import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import {
  getProviderCommodityClassifications,
  getProviderIps,
  getProviderItemCategories,
  getProviderItems,
  getProviderProviders,
  getProviderProvinces,
  getProviderWarehouses,
} from "store/provider-dashboard/provider-dashboard-action"

import { isEmpty, isObject } from "lodash"
import Preloader from "components/Common/Loader"
import {
  getByIdProviderOut,
  getProviderOutProviderAccounts,
  updateProviderOut,
} from "store/provider-out/provider-out-action"
import ProviderOutEditForm from "components/ProviderOut/EditForm"
import { providerOutAction } from "store/provider-out/provider-out-slice"

const EditProviderOut = () => {
  // Meta Title
  document.title = "Edit Distribution"

  // get params
  const params = useParams()
  const { id } = params

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, error } = useSelector(state => state.providerOut)

  // Retrieve distribution data from Redux store
  const distribution = useSelector(state => state.providerOut.distribution)

  // Retrieve warehosues data from Redux store
  const warehosues = useSelector(
    state => state.providerDashboard.providerWarehouses
  )
  // Retrieve providers data from Redux store
  const providers = useSelector(
    state => state.providerDashboard.providerProviders
  )

  // Retrieve categories data from Redux store
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  // Retrieve Unit Classification from Redux store
  const commodityClassifications = useSelector(
    state => state.providerDashboard.ProviderCommodityClassifications
  )

  // Retrieve ips data from Redux store
  const ips = useSelector(state => state.providerDashboard.ProviderIps)

  // Retrieve provider Accounts data from Redux store
  const providerAccounts = useSelector(
    state => state.providerOut.providerAccounts
  )

  // Retrieve items data from Redux store
  const items = useSelector(state => state.providerDashboard.ProviderItems)

  // Retrieve provinces data from Redux store
  const provinces = useSelector(
    state => state.providerDashboard.providerProvinces
  )
  // Retrieve facilities data from Redux store
  const facilities = useSelector(
    state => state.providerDashboard.providerFacilities
  )

  // Store filtered data and dispatch the action using onAdvancedSearchHandler callback function
  const handleSubmit = (values, file) => {
    // use formData to send file with values in server side
    const forms = new FormData()

    forms.append("_method", "put")
    forms.append("document", file)
    forms.append("old_document", distribution?.data?.document)
    forms.append("provider_in_id", distribution?.data?.provider_in_id)
    forms.append("id", distribution?.data?.id)
    forms.append(
      "distribution_reason",
      isObject(values.distribution_reason)
        ? values.distribution_reason.value
        : values.distribution_reason
    )
    forms.append(
      "item_category_id",
      isObject(values.item_category_id)
        ? values.item_category_id.value
        : values.item_category_id
    )
    forms.append(
      "item_id",
      isObject(values.item_id) ? values.item_id.value : values.item_id
    )

    forms.append(
      "provider_id",
      isObject(values.provider_id)
        ? values.provider_id.value
        : values.provider_id
    )
    forms.append(
      "province_id",
      isObject(values.province_id)
        ? values.province_id.value
        : values.province_id
    )

    const warehouse_disribute = isObject(values.warehouse_disribute)
      ? values.warehouse_disribute.value
      : values.warehouse_disribute

    forms.append("warehouse_disribute", warehouse_disribute)

    if (warehouse_disribute === "HFs") {
      forms.append(
        "facility_id",
        isObject(values.facility_id)
          ? values.facility_id.value
          : values.facility_id
      )
    } else {
      forms.append("facility_id", "")
    }

    forms.append(
      "ip_id",
      isObject(values.ip_id) ? values.ip_id.value : values.ip_id
    )
    forms.append(
      "warehouse_id",
      isObject(values.warehouse_id)
        ? values.warehouse_id.value
        : values.warehouse_id
    )
    forms.append("distributor", values.distributor)
    forms.append("out_quantity", values.out_quantity)
    forms.append("date", values.date)

    forms.append("distributed_type", values.distributed_type)
    forms.append("other_hfs", values.other_hfs)

    forms.append(
      "currency_id",
      isObject(values.currency_id)
        ? values.currency_id.value
        : values.currency_id
    )

    dispatch(updateProviderOut(id, forms, navigate))
  }

  // get provide out (distribution) by id and other data based select box form needs
  useEffect(() => {
    dispatch(getProviderWarehouses())
    dispatch(getProviderProviders())
    dispatch(getProviderItemCategories())
    dispatch(getProviderProvinces())
    dispatch(getProviderIps())
    dispatch(getProviderOutProviderAccounts())
    dispatch(getProviderCommodityClassifications())

    dispatch(getByIdProviderOut(id))

    return () => {
      dispatch(providerOutAction.resetState())
      dispatch(providerOutAction.resetProviderAccount())
    }
  }, [])

  // Check if record is locked and redirect if needed
  useEffect(() => {
    if (distribution?.data?.locked) {
      SAlert({
        title: "Cannot Edit",
        text: "This record cannot be modified until the transfer is approved or rejected.",
        status: "warning",
      })
      navigate("/provider-distributions")
    }
  }, [distribution, navigate])

  // useEffect(() => {
  //   dispatch(getProviderItems(distribution?.data?.item_category_id))
  // }, [distribution])

  return (
    <React.Fragment>
      {!isEmpty(distribution?.data) ? (
        // Provider Out Edit Form Component
        <ProviderOutEditForm
          onSubmit={handleSubmit}
          loading={loading}
          error={error}
          formMode={"Edit"}
          warehosues={warehosues?.data}
          providers={providers?.data}
          categories={categories?.data}
          items={items?.data}
          ips={ips?.data}
          provinces={provinces?.data}
          facilities={facilities?.data}
          distribution={distribution?.data}
          providerAccounts={providerAccounts?.data}
          commodityClassifications={commodityClassifications?.data}
        />
      ) : (
        <Preloader loading={true} />
      )}
    </React.Fragment>
  )
}

export default EditProviderOut
